import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

import DeviceApi from "../../../../api/DeviceApi";
import EventManager from "./common/event-manager/EventManager";
import DeviceMetricApi from "../../../../api/DeviceMetricApi";
import DeviceModel3D from "./components/device-model-3d/DeviceModel3D";
import DeviceTrack from "./components/device-track/DeviceTrack";
import DeviceDetails from "./components/device-details/DeviceDetails";
import DeviceMetrics from "./components/device-metrics/DeviceMetrics";
import DeviceRealtimeMetrics from "./components/device-realtime-metrics/DeviceRealtimeMetrics";
import ContentCard from "./common/content-card/ContentCard";
import Navigator from "../overview/components/navigator/Navigator";
import { DeviceDetailsContent, DeviceDetailsWrapper, DeviceModel3DWrapper, DeviceTrackWrapper, ElectricWheelDetailsScreenInnerWrapper, ElectricWheelDetailsScreenWrapper, ScreenTitleBar } from "./ElectricWheelDetailsScreen.styled";

interface ElectricWheelDetailsScreenProps {

}

let ElectricWheelDetailsScreen: React.FC<ElectricWheelDetailsScreenProps> = (props)=> {
    // parameters
    let params = useParams();
    let { deviceId } = useParams();

    // api
    let deviceApi = new DeviceApi();
    let deviceMetricApi = new DeviceMetricApi();
    
    // state
    let [deviceView, setDeviceView] = useState(null);
    let [deviceTemplateConfiguration, setDeviceTemplateConfiguration] = useState(null);
    
    // reference
    let eventManagerRef = useRef(new EventManager());

    // functions
    let fetchDeviceView = async ()=> {
        let deviceView = (await deviceApi.getDeviceViewByDeviceId(deviceId)).data.data;
        let deviceConfiguration = JSON.parse(deviceView.deviceTemplate.configuration);
        setDeviceView(deviceView);
        setDeviceTemplateConfiguration(deviceConfiguration);
    };

    let fetchLatestDeviceMetrics = async () => {
        if (deviceId == null) {
            return;
        }
        let latestDeviceMetrics = (await deviceMetricApi.getRealtimeDeviceMetricsSeries(deviceId, true)).data.data;
        eventManagerRef.current.notifyRealtimeDeviceMetricsSeriesUpdated(latestDeviceMetrics);
    };

    // effects
    useEffect(()=> {
        fetchDeviceView();
    }, []);

    useEffect(()=> {
        fetchLatestDeviceMetrics();
        let refreshTask = window.setInterval(fetchLatestDeviceMetrics, 10 * 1000);
        return ()=> window.clearInterval(refreshTask);
    }, [deviceId]);

    // render
    let deviceProperties = deviceTemplateConfiguration?.properties?.slice(0, 5) ?? [];

    return (
        <ElectricWheelDetailsScreenWrapper>
            <ElectricWheelDetailsScreenInnerWrapper>
                <ScreenTitleBar>
                    <Navigator selected="DEVICE_DETAILS"/>
                </ScreenTitleBar>

                <DeviceDetailsContent>
                    <DeviceTrackWrapper>
                        <DeviceTrack deviceId={deviceId} />
                    </DeviceTrackWrapper>

                    <DeviceModel3DWrapper>
                        <DeviceModel3D eventManager={eventManagerRef.current} />
                    </DeviceModel3DWrapper>

                    <DeviceDetailsWrapper
                        style={{
                            gridColumn: '9 / span 2',
                            gridRow: '1 / span 1'
                        }}>
                        <DeviceDetails eventManager={eventManagerRef.current} deviceId={deviceId} />
                    </DeviceDetailsWrapper>

                    <ContentCard
                        style={{
                            gridColumn: '9 / span 2',
                            gridRow: '2 / span 1'
                        }}
                        titleCn="实时数据" 
                        titleEn="REALTIME METRICS">
                        <DeviceRealtimeMetrics eventManager={eventManagerRef.current} deviceId={deviceId} />
                    </ContentCard>

                    {
                        deviceProperties.map((property, index)=> {
                            return <ContentCard 
                                key={property.key}
                                style={{
                                    gridColumn: `${index * 2 + 1} / span 2`,
                                    gridRow: '3 / span 1',
                                }}
                                titleCn={property.name}
                                titleEn="">
                                <DeviceMetrics eventManager={eventManagerRef.current} property={property} />
                            </ContentCard>
                        })
                    }
                </DeviceDetailsContent>
            </ElectricWheelDetailsScreenInnerWrapper>
        </ElectricWheelDetailsScreenWrapper>
    )
};

export default ElectricWheelDetailsScreen;

